import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const fullHeightMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: ({ refMap }): string => {
			const isFullHeight = refMap?.panelItem?.fullHeight ?? false;
			return isFullHeight ? 'Restore Height' : 'Full Height';
		},
		isVisible: ({ refMap }): boolean => {
			const { panelItem } = refMap ?? {};
			if (panelItem?.item.component.fullHeight !== true) return false;
			if (panelItem.item.sku?.endsWith('TK') && !panelItem.fullHeight) return false;
			return true;
		},
		onClick: ({ refMap }): void => {
			const { panelItem, panelItemGroup } = refMap ?? {};
			if (panelItem) {
				const newFullHeight = !panelItem.fullHeight;
				panelItem.fullHeight = newFullHeight;

				// sync sibling trim kits to match
				panelItemGroup?.items?.children
					.filter((sibling) => sibling !== panelItem && (sibling.item.sku?.endsWith('TK') ?? false))
					.forEach((trimKit) => { trimKit.fullHeight = newFullHeight; });
			}
		}
	};
};
